import { Box, Paper, PaperProps, Stack, styled } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Link } from 'react-router';

import { elevationLevel } from '@/styles/constants/paper';
import { doNotForwardTheseProps } from '@/styles/utils';

import { Icon } from '../Icon/Icon';
import { IconProps } from '../Icon/Icon.interface';

export const Container = styled((props: PaperProps) => (
  <Paper elevation={elevationLevel.header} {...props} />
))(({ theme }) => ({
  backgroundColor: theme.palette.primary1000.main,
  borderRadius: '0 0 24px 24px',
  position: 'fixed',
  left: 0,
  top: 0,
  width: '100%',
  height: theme.layout.headerHeight.lg,
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'stretch',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  gap: theme.spacing(3),
}));

export const LeftSlot = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(3),
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
}));

export const RightSlot = styled(LeftSlot)(({ theme }) => ({
  gap: theme.spacing(1),
  justifyContent: 'flex-end',
}));

export const CenterSlot = styled(LeftSlot)(({ theme }) => ({
  gap: theme.spacing(1),
  flex: 1,
  justifyContent: 'center',
}));

export const HeaderIcon = styled((props: IconProps) => (
  <Icon color={(theme: Theme) => theme.palette.common.white} {...props} />
))({});

export const NavLink = styled(Link, {
  shouldForwardProp: doNotForwardTheseProps('isHighlighted'),
})<{ isHighlighted?: boolean }>(({ theme, isHighlighted }) => ({
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  fontWeight: theme.typography.fontWeightMedium,
  gap: theme.spacing(1),
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  textDecoration: 'none',
  transition: theme.transitions.create(['background-color', 'color']),

  ...(isHighlighted
    ? {
        color: theme.palette.primary800.contrastText,
        backgroundColor: theme.palette.primary800.main,
      }
    : {
        color: theme.palette.grey[500],
      }),

  ':hover': {
    color: theme.palette.primary.contrastText,
  },
}));

export { LabelBadge as NavBadge } from '@/components/Badge';

export const RegionSelectContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    width: 264,
  },
}));
